import classNames from "classnames";
import type { DetailedHTMLProps, HtmlHTMLAttributes } from "react";
import { useMemo } from "react";

import Cell from "../Cell";
import type { TableCell, TableColumn } from "../types";

function Template({
    isCollapsed,
    columns,
    cells,
    renderCell,
    className,
    ...trProps
}: {
    isCollapsed?: boolean;
    columns: TableColumn[];
    cells: TableCell[];
    renderCell: (args: { cell: TableCell; column: TableColumn; index: number }) => JSX.Element;
    className?: string;
} & DetailedHTMLProps<HtmlHTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement>) {
    const columnsData = useMemo(() => {
        return columns.reduce<Record<string, TableColumn>>((acc, column) => {
            acc[column.id] = column;
            return acc;
        }, {});
    }, [columns]);

    return (
        <tr
            className={classNames(
                "flex flex-nowrap px-3!",
                {
                    "leading-0! border-b-0! opacity-0": isCollapsed,
                    "leading-4! border-b-[1px]! last-of-type:border-b-0! opacity-1": !isCollapsed,
                },
                className,
            )}
            {...trProps}
        >
            {cells.map((cell, index) => {
                const column = columnsData[cell.columnId];
                if (column?.isHidden) {
                    return null;
                }

                return (
                    <Cell key={cell.columnId} {...cell} column={column}>
                        {renderCell({ cell, column, index })}
                    </Cell>
                );
            })}
        </tr>
    );
}

export default Template;
